import React, { useEffect } from "react";
import './Service.css';
import Services from "./Service";
import ServiceFive from "./ServiceFive";
import ServiceTwo from "./ServiceTwo";
import ServicesHeader from './ServiceHeader';
import BrandSlider from "./Clients";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { useLocation } from "react-router-dom";
export default function ServicePage() {
    useEffect(() => {
        document.title = "Services - Pro Motors";
        console.log("service page called")
    }, []);

    const { pathname } = useLocation();
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return (
        <>
            <Header />
            <ServicesHeader />
            <Services />
            {/* <ServiceTwo /> */}
            <BrandSlider />
            <ServiceFive />
            <Footer />
        </>
    )
}